import React from 'react';
import { Space } from '@sravni/react-design-system';
import { AppStore } from '../AppStore/AppStore.js';

const AppStoresList = (props) => {
    const { refs, ...rest } = props;
    return (React.createElement(Space, { direction: "vertical", ...rest },
        React.createElement(Space, { size: 4 },
            React.createElement(AppStore, { ref: refs["RU_STORE" /* APP_STORES.RU_STORE */], store: "RU_STORE" /* APP_STORES.RU_STORE */ }),
            React.createElement(AppStore, { ref: refs["GOOGLE_PLAY" /* APP_STORES.GOOGLE_PLAY */], store: "GOOGLE_PLAY" /* APP_STORES.GOOGLE_PLAY */ })),
        React.createElement(Space, { size: 4 },
            React.createElement(AppStore, { ref: refs["HUAWEI_APP_GALLERY" /* APP_STORES.HUAWEI_APP_GALLERY */], store: "HUAWEI_APP_GALLERY" /* APP_STORES.HUAWEI_APP_GALLERY */ }),
            React.createElement(AppStore, { ref: refs["APPLE_STORE" /* APP_STORES.APPLE_STORE */], store: "APPLE_STORE" /* APP_STORES.APPLE_STORE */ }))));
};

export { AppStoresList };
//# sourceMappingURL=AppStoresList.js.map
